<template>
    <form @submit.prevent="changePassword">
        <div class="form-group" :class="{'form-group-feedback form-group-feedback-right': oldPasswordValid !== null}">
            <label>{{$t('profile.current_password')}}</label>
            <input v-model="form.oldPassword" @input="checkOldPassword" type="password" class="form-control" :class="{'border-success': oldPasswordValid === true, 'border-danger': oldPasswordValid === false}">

            <span v-if="oldPasswordValid === false" class="form-text" :class="oldPasswordValid ? 'text-success' : 'text-danger'">{{$t('profile.current_password_invalid')}}</span>
        </div>

        <div class="form-group">
            <label>{{$t('profile.new_password')}}</label>
            <input v-model="form.password"
                   type="password"
                   class="form-control"
                   :class="{'border-success': isPasswordValid && form.password.length > 0, 'border-danger': !isPasswordValid && form.password.length > 0}"
                   required
            >
        </div>

        <div class="form-group">
            <label>{{$t('profile.new_password_repeat')}}</label>
            <input v-model="form.passwordRepeat"
                   type="password"
                   class="form-control"
                   :class="{'border-success': passwordsAreEquals && form.passwordRepeat.length > 0, 'border-danger': !passwordsAreEquals && form.passwordRepeat.length > 0}"
                   required
            >
        </div>

        <span class="d-block text-muted mb-3">
          {{$t('auth.password_needs_to_contain')}}
          <span :class="{'text-success': hasAtLeastEightCharacters}">{{$t('auth.password_needs_eight_characters')}}</span>,
          <span :class="{'text-success': hasAtLeastOneBigLetter}"> {{$t('auth.password_needs_one_capital_letter')}}</span>
          {{$t('auth.password_needs_and')}}
          <span :class="{'text-success': hasAtLeastOneNumber}">{{$t('auth.password_needs_one_digit')}}</span>.
         </span>

        <div class="text-right">
            <BaseButtonSubmit
                    :text="$t('profile.change_password_save_button')"
                    :sending="saving"
                    :disabled="! formCanBeSend"
            />
        </div>
    </form>
</template>

<script>
    import {changePassword, checkPassword} from "../../services/UserService";
    import _ from 'lodash';
    import SystemNotificator from "../../services/SystemNotificator";

    export default {
        name: "UserChangePasswordForm",
        props: {
            user: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                form: {
                    oldPassword: '',
                    password: '',
                    passwordRepeat: ''
                },
                saving: false,
                oldPasswordValid: null
            }
        },

        computed: {
            passwordsAreEquals() {
                return this.form.password ===  this.form.passwordRepeat;
            },

            formCanBeSend() {
                return this.passwordIsFilledSufficiently
                    && this.oldPasswordValid;
            },

            passwordIsFilledSufficiently() {
                return this.passwordsAreEquals && this.isPasswordValid;
            },

            isPasswordValid() {
                return this.hasAtLeastEightCharacters
                    && this.hasAtLeastOneBigLetter
                    && this.hasAtLeastOneNumber;
            },

            hasAtLeastEightCharacters() {
                return this.form.password.length >= 8;
            },

            hasAtLeastOneBigLetter() {
                let match = this.form.password.match(/[A-Z]+/);

                return !! match;
            },

            hasAtLeastOneNumber() {
                let match = this.form.password.match(/[0-9]+/);

                return !! match;
            },

        },

        methods: {
            checkOldPassword: _.debounce(function() {
                this.oldPasswordValid = null;

                checkPassword(this.user.uuid, this.form.oldPassword)
                    .then(() => {
                        this.oldPasswordValid = true;
                    })
                    .catch(() => {
                        this.oldPasswordValid = false;
                    });
            }, 300),

            changePassword() {
                this.saving = true;
                changePassword(this.user.uuid, this.form)
                    .then(() => {
                        SystemNotificator.success({message: this.$t('profile.password_changed_successfully')});
                        this.cleanForm();
                    })
                    .catch(() => {
                        SystemNotificator.error({message: this.$t('profile.password_change_failed')});
                        this.saving = false
                    });
            },

            cleanForm() {
                this.form.password = '';
                this.form.passwordRepeat = '';
                this.form.oldPassword = '';
                this.saving = false;
                this.oldPasswordValid = null
            }
        }
    }
</script>

<style scoped>

</style>